export default __webpack_public_path__ + "static/media/2.1dbd2279.png";